import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import LiveFlights from "@/pages/LiveFlights";
import Ranks from "@/pages/Ranks";
import Roster from "@/pages/Roster";
import News from "@/pages/News";
import Events from "@/pages/Events";
import Activity from "@/pages/Activity";
import Tours from "@/pages/Tours";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster theme="dark" position="top-right" richColors />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/live-flights" element={<LiveFlights />} />
          <Route path="/ranks" element={<Ranks />} />
          <Route path="/roster" element={<Roster />} />
          <Route path="/news" element={<News />} />
          <Route path="/events" element={<Events />} />
          <Route path="/activity" element={<Activity />} />
          <Route path="/tours" element={<Tours />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
